import { apiRequest } from "./request";
import { ApiPaginationResponse, IUserJob, ApiPaginationRequest } from "@/types";

const getUserJob = (id: string) =>
    apiRequest<IUserJob>(`/user-job/${id}`, "GET");

const getAllUserJobs = (params?: ApiPaginationRequest) => {
    const requestParams: ApiPaginationRequest = {
        page: params?.page,
        limit: params?.limit,
        sortBy: params?.sortBy || "createdAt:desc",
    };

    return apiRequest<ApiPaginationResponse<IUserJob[]>>(
        `/user-job`,
        "GET",
        requestParams,
    );
};

const saveUserJob = (data: Partial<IUserJob>, id?: string) =>
    apiRequest<IUserJob>(
        id ? `/user-job/${id}` : "/user-job",
        id ? "PATCH" : "POST",
        data,
    );

const deleteUserJob = (id: string) => apiRequest(`/user-job/${id}`, "DELETE");

const updateUserJobLinkedResumes = (
    id: string,
    data: { linkedResumeIds?: string[]; resumeId?: string },
) => apiRequest(`/user-job/${id}/link`, "PATCH", data);

export default {
    saveUserJob,
    getUserJob,
    getAllUserJobs,
    deleteUserJob,
    updateUserJobLinkedResumes,
};
